<template>
  <v-row style="min-height: calc(100vh - 64px)">
    <v-col align="center" align-self="center" justify="center" height="auto">
      <v-img src="@core/assets/images/error-404.png" height="50vh" contain />
      <h3 class="mt-6">The page you are trying to reach doesn't exist.</h3>
      <p class="subtitle-1">Let's get you back.</p>
      <v-btn small color="dark" dark @click="goToDashboard()" v-track="'redirect-backto-dashboard'"> Back </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: "MError404",
  computed: {
    ...mapGetters({
      account: "auth/account",
    }),
  },
  methods:{
    /** redirecting back to dashboard page */
    goToDashboard(){
      if(this.account.id){
        this.$router.push({ name: 'dashboard',params:{accountId: this.account.id }});
      }
    }
  }
};
</script>
